import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { processSession } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          setError('No session ID found');
          setTimeout(() => navigate('/'), 2000);
          return;
        }

        // Process the session
        const user = await processSession(sessionId);
        
        // Clear the hash and redirect to home
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { state: { user } });
      } catch (err) {
        console.error('Auth callback error:', err);
        setError('Authentication failed. Please try again.');
        setTimeout(() => navigate('/'), 2000);
      }
    };

    handleAuth();
  }, []);

  return (
    <div className="min-h-screen bg-coconut flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-red-600 mb-2">{error}</p>
            <p className="text-text-subtle text-sm">Redirecting...</p>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-accent-ui mx-auto mb-4" />
            <p className="text-text-subtle">Signing you in...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
